import React from 'react';
import Dashboard from '../../components/admin/Dashboard';

const DashboardPage: React.FC = () => {
  return <Dashboard />;
};

export default DashboardPage;
